module.exports = __webpack_public_path__ + "img/TechGatherGold1_ua.928aac87.webp";